export default function swDev() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      let swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log("SW registered with scope:", registration.scope);
        })
        .catch((err) => {
          console.error("Registration failed:", err);
        });
    });
  }
}
